import { SetStateAction, Dispatch, useState } from "react";
import { gql, useQuery } from "@apollo/client";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TextField, FormControl, InputLabel, Select, MenuItem, Autocomplete, Grid } from "@mui/material";
import { useSelector } from "react-redux";
import { IProject } from "../../types/project";

import { IUser } from "../../types/user";
import { selectUser } from "../../features/auth/authSlice";

const CallFilter = (props: ChildProps) => {
  const user = useSelector(selectUser);
  const {
    dateStart,
    setDateStart,
    dateEnd,
    setDateEnd,
    projects,
    setProjects,
    direction,
    setDirection,
    setPageNumber,
    selectedUser,
    setSelectedUser,
  } = props;
  const [users, setUsers] = useState<IUser[]>([]);

  useQuery(GETUSERS, {
    skip: user?.type !== "Manager",
    variables: { filter: { OR: [{ type: "Sales" }, { type: "Manager" }, { type: "Admin" }], locked: false } },
    onCompleted: (data) => {
      setUsers(data.userMany.filter((crmUser: IUser) => crmUser.trackingPhone));
    },
    onError: (err) => {
      console.log(err);
    },
  });

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={4}>
        <Autocomplete
          options={[user?.projectAccess!.map((projectAccess: any) => projectAccess?.project)].flat()}
          freeSolo={false}
          value={projects}
          isOptionEqualToValue={(option, value) => option === value}
          getOptionLabel={(option: any) => option.name}
          onChange={(e, value) => {
            setProjects(value);
            if (value) setSelectedUser(undefined);
          }}
          renderInput={(params) => <TextField {...params} label="Project" />}
        />
      </Grid>
      {user?.type === "Manager" ? (
        <Grid item xs={12} sm={4}>
          <Autocomplete
            options={users}
            freeSolo={false}
            value={selectedUser ? selectedUser : null}
            isOptionEqualToValue={(option, value) => option._id === value._id}
            getOptionLabel={(option: any) => option.fullName}
            onChange={(e, value) => {
              setSelectedUser(value ? value : undefined);
              if (value) setProjects(null);
            }}
            renderInput={(params) => <TextField {...params} label="Personal Number" />}
          />
        </Grid>
      ) : null}
      <Grid item xs={12} sm={4}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            label="Date Start"
            value={dateStart ? new Date(dateStart!) : null}
            onChange={(newValue) => {
              setDateStart(newValue);
            }}
            maxDate={dateEnd ? new Date(dateEnd!) : new Date('2095-01-01')}
            sx={{ width: '100%'}}
          />
        </LocalizationProvider>
      </Grid>
      <Grid item xs={12} sm={4}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            label="Date End"
            value={dateEnd ? new Date(dateEnd!) : null}
            onChange={(newValue) => {
              setDateEnd(newValue);
            }}
            minDate={dateStart ? new Date(dateStart!) : new Date('2000-01-01')}
            sx={{ width: '100%'}}
          />
        </LocalizationProvider>
      </Grid>
      <Grid item xs={12} sm={4}>
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Direction</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            name={"direction"}
            label={"Direction"}
            value={direction}
            onChange={(e) => setDirection(e.target.value)}
          >
            <MenuItem value={"inbound"}>Inbound</MenuItem>
            <MenuItem value={"outbound"}>Outbound</MenuItem>
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
};

interface ChildProps {
  dateStart: Date | null;
  setDateStart: Dispatch<SetStateAction<Date | null>>;
  dateEnd: Date | null;
  setDateEnd: Dispatch<SetStateAction<Date | null>>;
  answerStatus: string;
  setAnswerStatus: Dispatch<SetStateAction<string>>;
  direction: string;
  setDirection: Dispatch<SetStateAction<string>>;
  projects: IProject | null;
  setProjects: any;
  setPageNumber: Dispatch<SetStateAction<number>>;
  selectedUser: IUser | undefined;
  setSelectedUser: Dispatch<SetStateAction<IUser | undefined>>;
}

const GETUSERS = gql`
  query userMany($filter: FilterFindManyUserInput!) {
    userMany(filter: $filter) {
      _id
      email
      fullName
      trackingPhone
    }
  }
`;

export default CallFilter;
